const urlMap = {
    home: '/',
    sample: '/sample-explorer',
    well: '/well-explorer',
    map: '/map',
    userCallback: '/user/callback',
    manageSampleResults: `/submissions`,
    uploadDialogue: '/submissions/new',
    edd: '/submissions/edd',
    wellEDD: '/submissions/edd/wellEDD',
    viewEDD: '/submissions/edd/view/:uploadId',
    reviewEDD: '/submissions/edd/review/:uploadId',
    form: '/submissions/:type',
    editForm: '/submissions/:type/:uploadId',
    viewForm: '/submissions/:type/view/:uploadId',
    reviewForm: '/submissions/:type/review/:uploadId',
    deactivateUser: '/user/deactivate/:userId',
    denyUser: '/user/deny/:userId',
}

const urls = urlMap

const mapUrlToName = Object.keys(urlMap).reduce((acc, cur) => {
    const name = urlMap[cur]
    return {
        ...acc,
        [name]: cur,
    }
}, {})

const createSubmissionUrl = (url, type) => url.replace(':type', type)

const formTypeToRoute = {
    'Merge Duplicate Wells': 'merge',
}

const isPageExplorer = location => {
    const explorerUrls = [urls.home, urls.sample, urls.well]
    return explorerUrls.includes(location.pathname)
}

export {
    formTypeToRoute,
    urls,
    mapUrlToName,
    isPageExplorer,
    createSubmissionUrl,
}
export default urls
